import { Button,ButtonGroup } from "@chakra-ui/react"
import { useState } from "react"

export default function ButtonC(props) {
  const { label,isLoading } = props;
  const [loading, setLoading] = useState(isLoading);
  
  return (
      <Button
        {...props}
        fontSize={"sm"}
        size="sm"
        loading={isLoading} 
        loadingText="Loading..."
        variant="solid"
        borderRadius={props.borderRadius || "md"}
        bg={props.bg || "var(--cr-red-logo)"}
        _dark={{ bg: "#f5faffff" }}
        _hover={{color:props.bg || "var(--cr-red-logo)",borderColor:props.bg ||"var(--cr-red-logo)", bg: "#fff"}}
        _focusVisible={{
          borderColor: "#1b96ff",
          boxShadow: "rgb(1, 118, 211) 0px 0px 3px 0px",
        }}
      >{label}</Button>
    
    
  )
}
